import {
  ERROR_ACTION,
  SET_ALL_ADVERTISEMENTS,
  SET_EXAMS,
  SET_SUBJECTS,
  SET_ALL_REPORT_COUNTS,
  GET_ALL_ANSWER_KEY_DATA,
  ANSWER_KEY_DATA_UPDATED_SUCCESS,
  SET_ALL_UNAPPROVAL_ENTITY_LIST,
  SET_UNAPPROVAL_PAGE_NO_COUNTER,
  ANSWER_KEY_DATA_FOR_APPROVAL,
  GET_ABSENTEE_LIST,
  SET_EXAMINERS_MODERATOR_REPORT_DATA,
  SET_SUPERVISORS,
  SET_DIFFERENTIAL_REPORT_DATA,
  SET_EXAMINERS_AND_MODERATOR_APPROVAL_PAGE_NO_COUNTER,
  SET_EXAMINERS_AND_MODERATOR_APPROVAL_LIST,
  SET_SUPERVISORS_BY_ID,
  SET_ALL_EXAMS,
  SET_MARKS_PDF,
  SET_INTERVIEW_MARKS_LIST,
  SET_INTERVIEW_MARKS_LIST_PAGE_NO_COUNTER,
  SET_ALL_UNAPPROVED_INTERVIEWMARKS_LIST,
  SET_UNAPPROVAL_INTERVIEWMARKS_PAGE_NO_COUNTER,
  SET_ALL_QUESTION_SETS,
  SET_ALL_ANSWER_KEYDATA,
  SET_ALL_ROLL_NUMBER_LIST,
  SET_UNAPPROVAL_RULE_PAGE_NO_COUNTER,
  SET_ALL_UNAPPROVAL_RULES_LIST,
  SET_RULES_CALCULATE_RESULT_DATA,
  SET_OBJECTIVE_STATUS_DATA,
  SET_VERSION_MISMATCH_LIST,
  SET_UNAPPROVAL_VERSION_MISMATCH_PAGE_NO_COUNTER,
  SET_UNAPPROVAL_VERSION_MISMATCH_LIST,
  SET_DUPLICATES_LIST,
  SET_OUT_OF_RANGE_LIST,
  SET_UNAPPROVAL_DUPLICATE_ROLL_NO_LIST,
  SET_UNAPPROVAL_OUT_OF_RANGE_COUNTER,
  SET_UNAPPROVAL_DUPLICATE_COUNTER,
  SET_UNAPPROVAL_OUT_OF_RANGE_LIST,
  SET_FILE_OBJECT,
  SET_UNAPPROVAL_ABSENTEE_LIST_COUNTER,
  SET_ABSENTEE_LIST,
  SET_UNAPPROVAL_ABSENTEE_LIST,
  SET_MARK_CRITERIA_APPROVAL_LIST,
  SET_MARK_CRITERIA_APPROVAL_PAGE_NO_COUNTER,
  GET_ALL_TOTAL_OF_STUDNETS,
  GET_MARK_DIFFERENCE_COUNT,
  GET_MODERATOR_MARK_COUNT,
  SET_CHIEF_MODERATOR_CRITERIA_APPROVAL_LIST,
  SET_CHIEF_MODERATOR_CRITERIA_APPROVAL_PAGE_NO_COUNTER,
  GET_MODERATOR_CANDIDATE_LIST,
  GET_CHIEF_MODERATOR_CANDIDATE_LIST,
  SET_MODERATOR_CRITERIA_APPROVAL_LIST,
  SET_MODERATOR_CRITERIA_APPROVAL_PAGE_NO_COUNTER,
  GET_PERCENTAGE_COUNT,
  SET_POST_CRITERIA,
  GET_POSTCRITERIA,
  GET_ALL_VIEW_MARKS,
  SET_MODERATOR_MARK_CRITERIA_STATUS,
  SET_CHIEF_MODERATOR_MARK_CRITERIA_STATUS,
  SET_RESERVED_SEATS_DATA,
  SET_ELIGIBLE_RECOMMANDATION_REPORT_DATA,
  SET_INVIGILATOR_VERSION_MISMATCH_LIST,
  SET_BARCODE_AND_ROLLNO,
  SET_MERITLIST_REPORT_DATA,
  SET_MODERATOR_MODERATION,
  SET_CHIEF_MODERATOR_MODERATION,
  SET_SUBJECT_CODE_ROLLNO,
  SET_EXAM_CODE_ROLLNO,
  SET_CRITERIA_CHECKING_LIST,
  SET_OBJECTIVE_STATUS_DATA_FLAG,
  SET_ANSWER_KEY_SET_LIST,
  SET_QUESTION_SET_LIST,
  GET_INTERVIEW_SCRUTINY_CANDIDATES
} from "../../common/constants/ActionTypes";

const initialState = {
  advertisementList: [],
  examList: [],
  allExamList: [],
  subjectList: [],
  supervisorList: [],
  supervisorListById: [],
  reportCountList: [],
  getAnswerKeyData: [],
  examinersAndModeratorReportData: [],
  differentialReportData: [],
  answerKeyDataUpdated: false,
  allUnapprovalEntityList: [],
  unapprovalPageNoCounter: 0,
  unapprovalRulePageNoCounter: 0,
  answerKeyDataForApproval: [],
  answerKeyDataList: [],
  questionSetList: [],
  allUnapprovalRulesList: [],
  rollNumberDataList: [],
  rulesCalculateResultData: [],
  objectiveStatusData: [],
  abseenteeList: [],
  examinersAndModeratorApprovalList: [],
  examinersAndModeratorApprovalPageNoCounter: 0,
  markCriteriaApprovalList: [],
  markCriteriaApprovalPageNoCounter: 0,
  chiefModeraatorCriteriaApprovalList: [],
  chiefModeraatorCriteriaApprovalPageNoCounter: 0,
  moderaatorCriteriaApprovalList: [],
  moderaatorCriteriaApprovalPageNoCounter: 0,
  allMarksPdf: [],
  unapprovalInterviewMarksPageNoCounter: 0,
  allUnapprovalInterviewMarksList: [],
  interviewMarksPageNoCounter: 0,
  allInterviewMarksList: [],
  versionMismatchList: [],
  invigilatorVersionMismatchList: [],
  unapprovalVersionMismatchPageNoCounter: 0,
  allUnapprovalVersionMismatchList: [],
  // allInterviewMarksList: [],
  duplicateList: [],
  outOfRangeList: [],
  absenteeList: [],
  unapprovalDuplicateRollNoList: [],
  unapprovalOutOfRangeList: [],
  unapprovalAbsenteeList: [],
  unapprovalDuplicateCounter: [],
  unapprovalOutOfRangeCounter: [],
  unapprovalAbsenteeListCounter: [],
  fileObject: {},
  totalStudentCount: [],
  marksDifferenceCount: [],
  moderatorMarkCount: [],
  moderatorCandidateList: [],
  chiefModeratorCandidateList: [],
  percentageCount: [],
  moderatorCriteriaStatus: [],
  chiefModeratorCriteriaStatus: [],
  reservedSeats: [],
  eligibleRecommandationReport: [],
  barcodeAndRollNoList: [],
  meritListReportData: [],
  getModerationData: [],
  getSubjectCodeRollNo: [],
  getExamCodeRollNo: [],
  criteriaForCheckingList: [],
  answerKeySetList: [],
  chiefModeratorPercentageCount: [],
  interviewScrutinyCandidates: [],


};

export default function postExaminationProcessObjectiveReducer(
  state = initialState,
  action
) {
  switch (action.type) {
    case SET_ALL_EXAMS:
      return {
        ...state,
        allExamList: action.payload,
      };
    case SET_ALL_ADVERTISEMENTS:
      return {
        ...state,
        advertisementList: action.payload,
      };
    case SET_EXAMS:
      return {
        ...state,
        examList: action.payload,
      };
    case SET_SUBJECTS:
      return {
        ...state,
        subjectList: action.payload,
      };
    case SET_SUPERVISORS:
      return {
        ...state,
        supervisorList: action.payload,
      };
    case SET_SUPERVISORS_BY_ID:
      return {
        ...state,
        supervisorListById: action.payload,
      };
    case SET_ALL_REPORT_COUNTS:
      return {
        ...state,
        reportCountList: action.payload,
      };
    case GET_ALL_ANSWER_KEY_DATA:
      return {
        ...state,
        getAnswerKeyData: action.payload,
      };
    case SET_EXAMINERS_MODERATOR_REPORT_DATA:
      return {
        ...state,
        examinersAndModeratorReportData: action.payload,
      };
    case SET_DIFFERENTIAL_REPORT_DATA:
      return {
        ...state,
        differentialReportData: action.payload,
      };
    case ERROR_ACTION:
      return {
        ...state,
        errorMessage: action.payload,
      };
    case ANSWER_KEY_DATA_UPDATED_SUCCESS:
      return {
        ...state,
        answerKeyDataUpdated: true,
      };
    case SET_UNAPPROVAL_DUPLICATE_ROLL_NO_LIST:
      return {
        ...state,
        unapprovalDuplicateRollNoList: action.payload,
      };
    case SET_UNAPPROVAL_OUT_OF_RANGE_LIST:
      return {
        ...state,
        unapprovalOutOfRangeList: action.payload,
      };
    case SET_UNAPPROVAL_ABSENTEE_LIST:
      return {
        ...state,
        unapprovalAbsenteeList: action.payload,
      };
    case SET_UNAPPROVAL_DUPLICATE_COUNTER:
      return {
        ...state,
        unapprovalDuplicateCounter: action.payload,
      };
    case SET_UNAPPROVAL_OUT_OF_RANGE_COUNTER:
      return {
        ...state,
        unapprovalOutOfRangeCounter: action.payload,
      };
    case SET_UNAPPROVAL_ABSENTEE_LIST_COUNTER:
      return {
        ...state,
        unapprovalAbsenteeListCounter: action.payload,
      };
    case SET_ALL_UNAPPROVAL_ENTITY_LIST:
      return {
        ...state,
        allUnapprovalEntityList: action.payload,
      };
    case SET_UNAPPROVAL_PAGE_NO_COUNTER:
      return {
        ...state,
        unapprovalPageNoCounter: action.payload,
      };
    case ANSWER_KEY_DATA_FOR_APPROVAL:
      return {
        ...state,
        answerKeyDataForApproval: action.payload,
      };
    case GET_ABSENTEE_LIST:
      return {
        ...state,
        abseenteeList: action.payload,
      };
    default:
      return state;
    case SET_EXAMINERS_AND_MODERATOR_APPROVAL_LIST:
      return {
        ...state,
        examinersAndModeratorApprovalList: action.payload,
      };
    case SET_EXAMINERS_AND_MODERATOR_APPROVAL_PAGE_NO_COUNTER:
      return {
        ...state,
        examinersAndModeratorApprovalPageNoCounter: action.payload,
      };
    case SET_MARK_CRITERIA_APPROVAL_LIST:
      return {
        ...state,
        markCriteriaApprovalList: action.payload,
      };
    case SET_MARK_CRITERIA_APPROVAL_PAGE_NO_COUNTER:
      return {
        ...state,
        markCriteriaApprovalPageNoCounter: action.payload,
      };
    case SET_MARKS_PDF:
      return {
        ...state,
        allMarksPdf: action.payload,
      };
    case SET_ALL_UNAPPROVED_INTERVIEWMARKS_LIST:
      return {
        ...state,
        allUnapprovalInterviewMarksList: action.payload,
      };

    case SET_UNAPPROVAL_INTERVIEWMARKS_PAGE_NO_COUNTER:
      return {
        ...state,
        unapprovalInterviewMarksPageNoCounter: action.payload,
      };
    case SET_INTERVIEW_MARKS_LIST:
      return {
        ...state,
        allInterviewMarksList: action.payload,
      };

    case SET_INTERVIEW_MARKS_LIST_PAGE_NO_COUNTER:
      return {
        ...state,
        interviewMarksPageNoCounter: action.payload,
      };
    // case SET_ALL_QUESTION_SETS:
    //   return {
    //     ...state,
    //     questionSetList: action.payload,
    //   };
    case SET_ALL_ANSWER_KEYDATA:
      return {
        ...state,
        answerKeyDataList: action.payload,
      };
    case SET_ALL_ROLL_NUMBER_LIST:
      return {
        ...state,
        rollNumberDataList: action.payload,
      };
    case SET_UNAPPROVAL_RULE_PAGE_NO_COUNTER:
      return {
        ...state,
        unapprovalRulePageNoCounter: action.payload,
      };
    case SET_ALL_UNAPPROVAL_RULES_LIST:
      return {
        ...state,
        allUnapprovalRulesList: action.payload,
      };
    case SET_RULES_CALCULATE_RESULT_DATA:
      return {
        ...state,
        rulesCalculateResultData: action.payload,
      };
    case SET_OBJECTIVE_STATUS_DATA:
      return {
        ...state,
        objectiveStatusData: action.payload,
      };
    case SET_VERSION_MISMATCH_LIST:
      return {
        ...state,
        versionMismatchList: action.payload,
      };
    case SET_INVIGILATOR_VERSION_MISMATCH_LIST:
      return {
        ...state,
        invigilatorVersionMismatchList: action.payload,
      };
    case SET_UNAPPROVAL_VERSION_MISMATCH_PAGE_NO_COUNTER:
      return {
        ...state,
        unapprovalVersionMismatchPageNoCounter: action.payload,
      };
    case SET_UNAPPROVAL_VERSION_MISMATCH_LIST:
      return {
        ...state,
        allUnapprovalVersionMismatchList: action.payload,
      };
    case SET_DUPLICATES_LIST:
      return {
        ...state,
        duplicateList: action.payload,
      };
    case SET_OUT_OF_RANGE_LIST:
      return {
        ...state,
        outOfRangeList: action.payload,
      };
    case SET_ABSENTEE_LIST:
      return {
        ...state,
        absenteeList: action.payload,
      };
    case SET_FILE_OBJECT:
      return {
        ...state,
        fileObject: action.payload,
      };
    case GET_ALL_TOTAL_OF_STUDNETS:
      return {
        ...state,
        totalStudentCount: action.payload,
      };
    case GET_MARK_DIFFERENCE_COUNT:
      return {
        ...state,
        marksDifferenceCount: action.payload,
      };
    case GET_MODERATOR_MARK_COUNT:
      return {
        ...state,
        moderatorMarkCount: action.payload,
      };
    case SET_CHIEF_MODERATOR_CRITERIA_APPROVAL_LIST:
      return {
        ...state,
        chiefModeratorCriteriaApprovalList: action.payload,

      };
    case SET_CHIEF_MODERATOR_CRITERIA_APPROVAL_PAGE_NO_COUNTER:
      return {
        ...state,
        chiefModeratorCriteriaApprovalPageNoCounter: action.payload,
      };
    case GET_MODERATOR_CANDIDATE_LIST:
      return {
        ...state,
        moderatorCandidateList: action.payload,
      };
    case GET_CHIEF_MODERATOR_CANDIDATE_LIST:
      return {
        ...state,
        chiefModeratorCandidateList: action.payload,
      };
    case SET_MODERATOR_CRITERIA_APPROVAL_LIST:
      return {
        ...state,
        moderatorCriteriaApprovalList: action.payload,
      };
    case SET_MODERATOR_CRITERIA_APPROVAL_PAGE_NO_COUNTER:
      return {
        ...state,
        moderatorCriteriaApprovalPageNoCounter: action.payload,
      };
    case GET_PERCENTAGE_COUNT:
      return {
        ...state,
        percentageCount: action.payload,
      };
    case SET_POST_CRITERIA:
      return {
        ...state,
        postcriteria: action.payload
      }
    case GET_POSTCRITERIA:
      return {
        ...state,
        postcriterialisting: action.payload
      }
    case SET_MODERATOR_MARK_CRITERIA_STATUS:
      return {
        ...state,
        moderatorCriteriaStatus: action.payload
      }
    case GET_POSTCRITERIA:
      return {
        ...state,
        postcriterialisting: action.payload
      }
    case GET_ALL_VIEW_MARKS:
      return {
        ...state,
        viewMarksList: action.payload
      }
    case SET_CHIEF_MODERATOR_MARK_CRITERIA_STATUS:
      return {
        ...state,
        chiefModeratorCriteriaStatus: action.payload
      }
    // case GET_POSTCRITERIA:
    //   return {
    //     ...state,
    //     postcriterialisting: action.payload
    //   }
    case GET_ALL_VIEW_MARKS:
      return {
        ...state,
        viewMarksList: action.payload
      }
    case SET_RESERVED_SEATS_DATA:
      return {
        ...state,
        reservedSeats: action.payload
      }
    case SET_ELIGIBLE_RECOMMANDATION_REPORT_DATA:
      return {
        ...state,
        eligibleRecommandationReport: action.payload
      }
    case SET_BARCODE_AND_ROLLNO:
      return {
        ...state,
        barcodeAndRollNoList: action.payload
      }
    case SET_MERITLIST_REPORT_DATA:
      return {
        ...state,
        meritListReportData: action.payload
      }
    case SET_MODERATOR_MODERATION:
      return {
        ...state,
        getModerationData: action.payload
      }
    case SET_CHIEF_MODERATOR_MODERATION:
      return {
        ...state,
        getModerationData: action.payload
      }
    case SET_SUBJECT_CODE_ROLLNO:
      return {
        ...state,
        getSubjectCodeRollNo: action.payload
      }
    case SET_EXAM_CODE_ROLLNO:
      return {
        ...state,
        getExamCodeRollNo: action.payload
      }
    case SET_CRITERIA_CHECKING_LIST:
      return {
        ...state,
        criteriaForCheckingList: action.payload
      }
    case SET_OBJECTIVE_STATUS_DATA_FLAG:
          console.log("Reducer Payload", action.payload);
      return {
        ...state,
        objectiveStatusDataFlag: action.payload
      }
    case SET_ANSWER_KEY_SET_LIST:
      return {
        ...state,
        answerKeySetList: action.payload
      }
    // case SET_ABSENTEE_LIST:
    //     return {
    //       ...state,
    //       absenteeList: action.payload,
    //     }; 

    case SET_QUESTION_SET_LIST:
      return {
        ...state,
        questionSetList: action.payload,
      };
    case "SET_VIEW_RESULT_DATA":
      return {
        ...state,
        viewMarksList: [],
      };
    case "GET_CHIEF_MODERATOR_PERCENTAGE_COUNT":
  return {
    ...state,
    chiefModeratorPercentageCount: action.payload,
  };
  case GET_INTERVIEW_SCRUTINY_CANDIDATES:
  return {
    ...state,
    interviewScrutinyCandidates: action.payload,
  };
  }
}

